import {  getAllToken } from 'Lib'

export function getUsers(state, props) {
    return state.users
}

export function getUserInfo(state, props) {
    return state.userInfo
}

export function getAuthState(state, props) {
    return state.auth
}

export function getIsLoggedIn(state){
    const {access_token} = getAllToken()
    return !!access_token
}

export function getChangeSendMailResetPassword(state){
    return state.sendMailResetPassword
}

export function getHasSendReport(state){
    return state.hasSendReport
}

export function getSendEmail(state){
    return state.sendMail
}

export function getSettings(state, props) {
    return state.settings
}



// WEBPACK FOOTER //
// ./src/features/user/selectors.js